import useCreateMerchantServiceCategory from "@/services/appointment/hooks/useCreateMerchantServiceCategory";
import { CreateMerchantServiceCategoryPayload } from "@/services/appointment/type";
import { Button, Card, Stack, Textarea, TextInput } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

const schema = Yup.object().shape({
  title: Yup.string().required("لطفا نام سرویس را وارد نمایید"),
});
function AddCategory() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { mutate, isLoading } = useCreateMerchantServiceCategory();

  const form = useForm<CreateMerchantServiceCategoryPayload>({
    initialValues: {
      title: "",
      description: "",
    },
    validate: yupResolver(schema),
  });

  const submit = (values: CreateMerchantServiceCategoryPayload) => {
    mutate(
      {
        title: values?.title,
        description: values?.description,
      },
      {
        onSuccess() {
          notifications.show({
            title: "عملیات موفق",
            message: "عملیات با موفقیت صورت پذیرفت",
            color: "green",
          });
          navigate(-1);
          queryClient.invalidateQueries({
            queryKey: ["getMerchantServices"],
          });
          queryClient.refetchQueries(["getMerchantServices"]);
        },
      }
    );
  };
  return (
    <>
      <Stack mt="md" justify="start" flex={1}>
        <form
          onSubmit={form.onSubmit(submit)}
          name="add-category"
          className="w-100"
          id="add-category"
        >
          <Stack>
            <TextInput
              styles={{
                label: {
                  fontSize: "1rem",
                },
              }}
              size="lg"
              placeholder=""
              withAsterisk
              description="به عنوان مثال : مو"
              label="عنوان"
              {...form.getInputProps("title")}
            />

            <Textarea
              styles={{
                label: {
                  fontSize: "1rem",
                },
              }}
              size="lg"
              label="توضیحات"
              {...form.getInputProps("description")}
            />
          </Stack>
        </form>
      </Stack>
      <Card
        styles={{
          root: {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 10,
          },
        }}
        withBorder
        radius={0}
      >
        <Button
          size="lg"
          fullWidth
          type="submit"
          form="add-category"
          loading={isLoading}
        >
          افزودن
        </Button>
      </Card>
    </>
  );
}

export default AddCategory;
